import * as React from "react";
import { useRef, useState } from "react";
import { styled } from "@mui/material";
import { GenericButton } from "../uiControllers/genericButton";
import { useTranslate } from "../../hooks/useTranslate";
import { useGetProviderLink } from "../../solverHooks/saveConversation";
import { PatientColorMap } from "../../layout/patientColorMap";
import { usePatient } from "../../state/patientContext";

//region [[ Styles ]]

const KahunPatientLinkButtonView = styled("div")({
  display: "flex",
  flexFlow: "column",
  width: "100%",
});

const LinkToPatientContainer = styled("div")({
  display: "flex",
  flexFlow: "row",
  justifyContent: "flex-end",
  width: "100%",
  margin: "12px 0",
});

const InsightButton = styled(GenericButton)({
  "&.generic-button.clicked": {
    background: PatientColorMap.Primary,
    color: PatientColorMap.White,
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface KahunPatientLinkButtonProps {
  className?: string;
  children?: React.ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
// Detects if device is on iOS
export const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

//endregion [[ Functions ]]

export const KahunPatientLinkButton = ({
  ...props
}: KahunPatientLinkButtonProps) => {
  const [loading, setLoading] = useState(false);

  const { translate } = useTranslate();

  const providerLink = useGetProviderLink();

  const { setAbandoned } = usePatient();

  const windowRef = useRef<Window>();

  const goToPatientCard = () => {
    setLoading(true);
    windowRef.current = window.open(providerLink);

    setAbandoned(true)
      .then(() => {
        windowRef.current?.location?.reload();
        windowRef.current?.focus?.();
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };
  return (
    <KahunPatientLinkButtonView className={props.className}>
      {props.children}
      <LinkToPatientContainer className={"button-container"}>
        <InsightButton
          disabled={loading}
          onClick={goToPatientCard}
          label={"💡 " + translate("SHOW_KAHUN_INSIGHT")}
          allowReclicking
        />
      </LinkToPatientContainer>
    </KahunPatientLinkButtonView>
  );
};
